/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import {
  renownAppProfileMetricsActions,
  renownAppProfileProfileActions,
} from "./gen/creators.js";

/** Actions for the RenownAppProfile document model */

export const actions = {
  ...baseActions,
  ...renownAppProfileProfileActions,
  ...renownAppProfileMetricsActions,
};
